<template>
  <layout-panel>
    <template slot="header">1. 来源分配 & 抽检比例</template>
    <el-table :data="internList"
              v-loading="loading"
              stripe
              border
              style="width: 100%">
      <el-table-column label="实习生ID"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.intern_user_id != null ? scope.row.intern_user_id : (scope.row.id != null ? scope.row.id : '-') }}
        </template>
      </el-table-column>
      <el-table-column prop="name"
                       label="实习生">
      </el-table-column>
      <el-table-column prop="count"
                       label="总单量"
                       align="center">
      </el-table-column>
      <el-table-column label="抽检比例"
                       align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.sampleRate"
                    type="number"
                    size="small"
                    placeholder=""
                    min="0"
                    max="100"
                    step="1"
                    class="sample-rate-input"
                    @input="onInternSampleRateChange(scope.row)">
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column :label="`预计(总计${totalExpected})`"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.expected != null ? scope.row.expected : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       fixed="right">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="removeIntern(scope.$index)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </layout-panel>
</template>

<script>
import { getPendingReviewTaskStats } from '@/views/order/order.api'

export default {
  name: 'SourceAllocationPanel',
  props: {
    // 从列表页跳转时携带的检索参数（如 mode、orderid、projectid 等）
    queryParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      internList: [],
      loading: false
    }
  },
  computed: {
    totalExpected () {
      return this.internList.reduce((sum, row) => sum + (Number(row.expected) || 0), 0)
    }
  },
  watch: {
    totalExpected: {
      handler (val) {
        this.$emit('total-expected', val)
      },
      immediate: true
    },
    queryParams: {
      handler () {
        this.fetchInternList()
      },
      deep: true
    }
  },
  created () {
    this.fetchInternList()
  },
  methods: {
    fetchInternList () {
      this.loading = true
      const params = this.queryParams && typeof this.queryParams === 'object' ? { ...this.queryParams } : {}
      getPendingReviewTaskStats(params)
        .then(res => {
          const detail = res && res.data && res.data.detail
          this.internList = Array.isArray(detail) ? detail : []
          this.internList.forEach(row => this.calcInternExpected(row))
        })
        .catch(() => {
          this.internList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    applySampleRate (rate) {
      if (rate === '' || rate == null) return
      const clamped = Math.min(100, Math.max(0, Number(rate) || 0))
      this.internList.forEach(row => {
        row.sampleRate = String(clamped)
        this.calcInternExpected(row)
      })
    },
    onInternSampleRateChange (row) {
      const raw = String(row.sampleRate || '').replace(/\D/g, '').slice(0, 3)
      if (raw === '') {
        row.sampleRate = ''
      } else {
        const num = Math.min(100, Math.max(0, parseInt(raw, 10) || 0))
        row.sampleRate = String(num)
      }
      this.calcInternExpected(row)
    },
    // 预计(向下取整)=总单量*抽检比例；抽检比例=0则预计=0；抽检比例>0但预计<1则预计=1
    calcInternExpected (row) {
      const total = Number(row.totalCount != null ? row.totalCount : row.count) || 0
      const rate = Number(row.sampleRate) || 0
      if (rate === 0) {
        this.$set(row, 'expected', 0)
        return
      }
      const val = Math.floor(total * rate / 100)
      this.$set(row, 'expected', val < 1 ? 1 : val)
    },
    removeIntern (index) {
      this.internList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.sample-rate-input /deep/ input[type='number']::-webkit-outer-spin-button,
.sample-rate-input /deep/ input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.sample-rate-input /deep/ input[type='number'] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/SourceAllocationPanel.vue